import { render, staticRenderFns } from "./CampaignTimeLeft.vue?vue&type=template&id=3680e587&scoped=true"
import script from "./CampaignTimeLeft.vue?vue&type=script&lang=ts"
export * from "./CampaignTimeLeft.vue?vue&type=script&lang=ts"
import style0 from "./CampaignTimeLeft.vue?vue&type=style&index=0&id=3680e587&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680e587",
  null
  
)

export default component.exports